/// <reference types="./SchemaModernizer.d.ts" />
import { FieldType, RichTextNodeType, } from '@dossierhq/core';
export function modernizeSchemaSpecification(specification) {
    const payload = {
        schemaKind: 'full',
        version: specification.version,
        entityTypes: specification.entityTypes.map(modernizeEntityType),
        componentTypes: [],
        patterns: specification.patterns ?? [],
        indexes: specification.indexes ?? [],
        migrations: specification.migrations?.map((it) => ({
            ...it,
            actions: it.actions.map(modernizeMigrationAction),
        })) ?? [],
    };
    // Version 0.5: renamed valueTypes to componentTypes
    if ('componentTypes' in specification) {
        payload.componentTypes = specification.componentTypes.map(modernizeComponentType);
    }
    else {
        payload.componentTypes = specification.valueTypes.map(modernizeComponentType);
    }
    return payload;
}
function modernizeEntityType(typeSpec) {
    // Version 0.2.3: moved isName from field to nameField on entity types, isName is deprecated
    if (typeSpec.nameField === undefined) {
        typeSpec.nameField =
            typeSpec.fields.find((it) => it.isName)?.name ?? null;
        for (const fieldSpec of typeSpec.fields) {
            delete fieldSpec.isName;
        }
    }
    // Version 0.7: renamed adminOnly to publishable (inverted meaning)
    if ('adminOnly' in typeSpec) {
        typeSpec.publishable = !typeSpec.adminOnly;
        delete typeSpec.adminOnly;
    }
    typeSpec.fields = typeSpec.fields.map(modernizeField);
    return typeSpec;
}
function modernizeComponentType(typeSpec) {
    typeSpec.fields = typeSpec.fields.map(modernizeField);
    return typeSpec;
}
function modernizeField(fieldSpec) {
    // Version 0.2.3: moved isName from field to nameField on entity types, isName is deprecated
    delete fieldSpec.isName;
    // Field types were renamed
    if (fieldSpec.type === 'EntityType')
        fieldSpec.type = FieldType.Reference;
    if (fieldSpec.type === 'ValueType')
        fieldSpec.type = FieldType.Component;
    // Version 0.5: renamed ValueItem to Component
    if (fieldSpec.type === 'ValueItem')
        fieldSpec.type = FieldType.Component;
    // Version 0.7: renamed Entity to Reference
    if (fieldSpec.type === 'Entity')
        fieldSpec.type = FieldType.Reference;
    if (fieldSpec.type === FieldType.Component) {
        // Version 0.5: renamed valueTypes to componentTypes
        if ('valueTypes' in fieldSpec) {
            fieldSpec.componentTypes = fieldSpec.valueTypes;
            delete fieldSpec.valueTypes;
        }
    }
    else if (fieldSpec.type === FieldType.String) {
        // Version 0.2.15: added values to string fields
        if (fieldSpec.values === undefined)
            fieldSpec.values = [];
    }
    else if (fieldSpec.type === FieldType.RichText) {
        // Version 0.3.2: added tab as required node
        if (fieldSpec.richTextNodes.length > 0 &&
            !fieldSpec.richTextNodes.includes(RichTextNodeType.tab)) {
            fieldSpec.richTextNodes.push('tab');
            fieldSpec.richTextNodes.sort();
        }
        // Version 0.5: renamed valueItem to component
        const valueItemIndex = fieldSpec.richTextNodes.indexOf('valueItem');
        if (valueItemIndex >= 0) {
            fieldSpec.richTextNodes[valueItemIndex] = 'component';
            fieldSpec.richTextNodes.sort();
        }
        // Version 0.5: renamed valueTypes to componentTypes
        if ('valueTypes' in fieldSpec) {
            fieldSpec.componentTypes = fieldSpec.valueTypes;
            delete fieldSpec.valueTypes;
        }
    }
    return fieldSpec;
}
function modernizeMigrationAction(action) {
    if ('valueType' in action) {
        action.componentType = action.valueType;
        delete action.valueType;
    }
    return action;
}
//# sourceMappingURL=SchemaModernizer.js.map